<template>
  <v-layout row wrap>
    <!-- Cột Trái: Đối tác & Nhân sự phụ trách -->
    <v-flex xs12 md6 class="pr-md-4 border-right-slate">
      <div class="mb-4">
        <div class="d-flex align-center mb-3">
          <span class="accent-bar-blue mr-2"></span>
          <span class="subtitle-2 font-weight-bold text-slate-800 text-uppercase tracking-wide">Thông tin Khách hàng & Nhân sự</span>
        </div>
        <v-card flat class="pa-3 rounded-lg bg-blue-gradient border">
          <v-layout row wrap>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                label="Họ tên khách hàng"
                :value="customer.Username"
                variant="outlined"
                dense
                outlined
                hide-details
                readonly
                prepend-inner-icon="fas fa-user"
                color="primary"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                label="Số điện thoại"
                :value="adminRole ? customer.Phone : '******'"
                variant="outlined"
                dense
                outlined
                hide-details
                readonly
                prepend-inner-icon="fas fa-phone"
                color="primary"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="pa-2">
              <v-text-field
                label="Địa chỉ nhận hàng"
                :value="customer.Address || 'Liên hệ khách hàng'"
                readonly
                dense
                outlined
                hide-details
                prepend-inner-icon="fas fa-map-marker-alt"
                color="primary"
              ></v-text-field>
            </v-flex>
            <template v-if="(orderRole & 2)">
              <v-flex xs12 sm6 class="pa-2">
                <v-select
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="fas fa-headset"
                  label="Nhân viên CSKH"
                  :items="cs_staffs"
                  v-model="orderEditable.CustomerServiceID"
                  item-text="FullName"
                  item-value="ID"
                  :disabled="orderReadonly || !adminRole"
                  color="primary"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="fas fa-user-tie"
                  label="Mua hàng"
                  :items="p_staffs"
                  v-model="orderEditable.BuyerID"
                  item-text="FullName"
                  item-value="ID"
                  :disabled="orderReadonly || !adminRole"
                  color="primary"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="fas fa-user-tag"
                  label="Nhân viên Sale"
                  :items="saleStaffList"
                  v-model="orderEditable.SalerID"
                  item-text="FullName"
                  item-value="ID"
                  :disabled="orderReadonly || !adminRole"
                  color="primary"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="fas fa-file-contract"
                  label="Nhân viên XNK"
                  :items="xnkStaffList"
                  v-model="orderEditable.XNKID"
                  item-text="FullName"
                  item-value="ID"
                  :disabled="orderReadonly || !adminRole"
                  color="primary"
                ></v-select>
              </v-flex>
            </template>
            <v-flex xs12 class="pa-2" v-if="order.WeChatId && order.WeChatId != ''">
              <v-text-field
                label="WeChat ID"
                v-model="orderEditable.WeChatId"
                variant="outlined"
                dense
                outlined
                hide-details
                prepend-inner-icon="fab fa-weixin"
                color="primary"
                :disabled="orderReadonly"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
      </div>

      <div class="mb-4">
        <div class="d-flex align-center mb-3">
          <span class="accent-bar-teal mr-2"></span>
          <span class="subtitle-2 font-weight-bold text-slate-800 text-uppercase tracking-wide">Logistics & Loại hàng</span>
        </div>
        <v-card flat class="pa-3 rounded-lg bg-teal-gradient border">
          <v-layout row wrap>
            <template v-if="(orderRole & 2)">
              <v-flex xs12 sm6 class="pa-2">
                <v-select
                  :disabled="orderReadonly || storeRole"
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="fas fa-warehouse"
                  label="Kho gửi TQ"
                  :items="chinaStores"
                  v-model="orderEditable.ChinaStoreID"
                  item-text="Name"
                  item-value="ID"
                  color="primary"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select
                  :disabled="orderReadonly || storeRole"
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="fas fa-warehouse"
                  label="Kho nhận VN"
                  :items="warehouses"
                  v-model="orderEditable.ReceivePlaceID"
                  item-text="Name"
                  item-value="ID"
                  color="primary"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select
                  :disabled="orderReadonly || storeRole"
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="fas fa-tags"
                  label="Loại hàng hóa"
                  :items="list_product_types"
                  v-model="orderEditable.ProductType"
                  item-text="Name"
                  item-value="ID"
                  color="primary"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select
                  :disabled="orderReadonly || storeRole"
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="fas fa-file-invoice"
                  label="Loại đơn"
                  :items="['NKCN', 'NKTN']"
                  v-model="orderEditable.OrderType"
                  color="primary"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2" v-if="orderEditable.OrderType === 'NKCN'">
                <v-checkbox
                  :disabled="orderReadonly || storeRole"
                  v-model="orderEditable.IsProcessedCN"
                  label="Xử lý chính ngạch (Xử lý CN)"
                  dense
                  hide-details
                  color="success"
                  class="mt-1"
                ></v-checkbox>
              </v-flex>
            </template>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                label="Phương thức vận chuyển"
                value="Vận chuyển nhanh TQ - VN"
                readonly
                dense
                outlined
                hide-details
                prepend-inner-icon="fas fa-truck"
                color="primary"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
      </div>

      <!-- Ghi chú đơn hàng -->
      <div v-if="showOrderNotes" class="mb-4">
        <div class="d-flex align-center mb-3">
          <span class="accent-bar-blue mr-2"></span>
          <span class="subtitle-2 font-weight-bold text-slate-800 text-uppercase tracking-wide">Ghi chú đơn hàng</span>
        </div>
        <v-layout row wrap>
          <v-flex xs12 class="pa-2">
            <v-textarea
              outlined
              v-model="orderEditable.Note"
              label="Ghi chú đơn hàng"
              background-color="#fcfcfc"
              dense
              rows="4"
              hide-details
              prepend-inner-icon="far fa-comment"
              class="input-group--focused rounded-lg border-slate-200"
              :disabled="orderReadonly"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>

    <!-- Cột Phải: Ghi chú -->
    <v-flex xs12 md6 class="pl-md-4">
      <!-- Hộp chat -->
      <div v-if="showChat && order && order.ID" class="mb-4">
        <div class="d-flex align-center mb-3">
          <span class="accent-bar-purple mr-2"></span>
          <span class="subtitle-2 font-weight-bold text-slate-800 text-uppercase tracking-wide">Tin nhắn</span>
        </div>
        <v-layout row wrap>
          <v-flex xs12 class="pa-2">
            <message-box :orderId="order.ID" :orderType="1" :height="chatHeight"></message-box>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import configs from "@/configs";
import MessageBox from "@/components/chat/MessageBox";

export default {
  name: "TabGeneralInfo",
  components: {
    MessageBox
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    customer: {
      type: Object,
      required: true
    },
    orderEditable: {
      type: Object,
      required: true
    },
    orderRole: {
      type: Number,
      required: true
    },
    orderReadonly: {
      type: Boolean,
      required: true
    },
    adminRole: {
      type: Boolean,
      required: true
    },
    storeRole: {
      type: Boolean,
      required: true
    },
    cs_staffs: {
      type: Array,
      required: true
    },
    p_staffs: {
      type: Array,
      required: true
    },
    sale_staffs: {
      type: Array,
      default: () => []
    },
    xnk_staffs: {
      type: Array,
      default: () => []
    },
    chinaStores: {
      type: Array,
      required: true
    },
    warehouses: {
      type: Array,
      required: true
    },
    list_product_types: {
      type: Array,
      required: true
    }
  },
  computed: {
    saleStaffList() {
      if (this.sale_staffs && this.sale_staffs.length) return this.sale_staffs;
      const allUsers = this.$store.state.commons.all_users || [];
      return allUsers.filter(o => (o.RoleType & configs.ROLE_TYPE.Sale) === configs.ROLE_TYPE.Sale);
    },
    xnkStaffList() {
      if (this.xnk_staffs && this.xnk_staffs.length) return this.xnk_staffs;
      const allUsers = this.$store.state.commons.all_users || [];
      return allUsers.filter(o => (o.RoleType & configs.ROLE_TYPE.Officer) === configs.ROLE_TYPE.Officer);
    },
    showChat() {
      return this.$store.state.commons.orderWidgetSettings && this.$store.state.commons.orderWidgetSettings.chat && (this.orderRole & 16);
    },
    showOrderNotes() {
      const user = this.$store.state.authentication.user;
      if (!user) return false;
      const allowedRoles = configs.ROLE_TYPE.Admin | configs.ROLE_TYPE.Manager | configs.ROLE_TYPE.Purchase | configs.ROLE_TYPE.Payment;
      return (user.roletype & allowedRoles) > 0;
    },
    chatHeight() {
      return this.showOrderNotes ? '550px' : '400px';
    }
  }
};
</script>

<style scoped>
.accent-bar-purple {
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #7c3aed !important;
    border-radius: 4px;
}
.accent-bar-blue {
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #111827 !important;
    border-radius: 4px;
}
</style>
